import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { startAlerta } from "../../../actions/ui/alertas";
import { startSpinner, finishSpinner } from "../../../actions/ui/spinner";
import BuscadorMedicamento from "./BuscadorMedicamento";
import { addMedicamento } from "../../../actions/recetasDigitales/RecetasDigitales";
import { Button, Grid } from "@material-ui/core";

export const RecetasDigitalesAddMedicamento = () => {
  const dispatch = useDispatch();

  const { recetaSeleccionada = {}, medicamentos } = useSelector((state) => state.recetasDigitales);

  const [codigoMedicamento, setCodigoMedicamento] = useState(null);
  const codigoMedicamentoRef = useRef(null);


  const onClickAgregarHandler = () => {
    console.log(medicamentos?.find((med) => med.idMedicamento === codigoMedicamento.idMedicamento));
    if (codigoMedicamento) {
      if (medicamentos?.find((med) => med.idMedicamento === codigoMedicamento.idMedicamento)) {
        dispatch(startAlerta("El medicamento ya se encuentra agregado", "warning", "Atencion"));
      } else {
        const medicamentoAuth = {
          idRecetaDigital: recetaSeleccionada.idRecetaDigital,
          cant: 1,
          idMedicamento: codigoMedicamento.idMedicamento,
          medicamento: {
            nombre: codigoMedicamento.nombre,
            laboratorio: codigoMedicamento.laboratorio,
            presentacion: codigoMedicamento.presentacion,
            drogas: codigoMedicamento.drogas,
          },
          dosis: "",
          posologia: "",
          idTipoReceta: recetaSeleccionada.idTipoReceta,
        };
        dispatch(startSpinner());
        dispatch(addMedicamento(medicamentoAuth));
  
        dispatch(finishSpinner());
        codigoMedicamentoRef.current.resetValues();
        setCodigoMedicamento(null);
      }
      
    } else {
      dispatch(startAlerta("Ingrese un medicamento", "warning", "Atencion"));
    }
  };

  return (
    <React.Fragment>
      <Grid
        container
        spacing={2}
        style={{ width: "60%", margin: "auto", marginTop: "1rem" }}
      >
        <Grid item xs={12}>
          <BuscadorMedicamento
            ref={codigoMedicamentoRef}
            cod={codigoMedicamento}
            label="Medicamento (Presentación | Laboratorio | Nombre | Drogas)"
            fieldsDisabled={false}
            autorizacion={true}
            setCod={(val) => setCodigoMedicamento(val)}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ width: "60%", margin: "auto" }}>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "1.5rem 0",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={onClickAgregarHandler}
          >
            Agregar +
          </Button>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
